import { Text } from '@ps-design-system/components/Text';
import PropTypes from 'prop-types';
import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import { SocialEventPolicyForm } from '../checkout-forms/SocialEventPolicyForm/SocialEventPolicyForm';

export const SocialEventPolicySection = ({ urlPrefix }) => {
  return (
    <div data-testingid="social-event-policy-section">
      <Text element="h4" typeface="headline-3-b" style={{ margin: '0px' }}>
        <FormattedMessage
          id="social_event_policy.review_policy"
          defaultMessage="Review event policy"
        />
      </Text>

      <div style={{ margin: '24px 0' }}>
        <ul style={{ color: '#6A6E7A' }}>
          <li style={{ display: 'flex', alignItems: 'start', gap: '8px' }}>
            &bull;
            <Text>
              <FormattedMessage
                id="social_event_policy.end_by_midnight"
                defaultMessage="Social events must end by 12 AM"
              />
            </Text>
          </li>
          <li style={{ display: 'flex', alignItems: 'start', gap: '8px' }}>
            &bull;
            <Text>
              <FormattedMessage
                id="social_event_policy.event_insurance"
                defaultMessage="Special event insurance is required for this booking to proceed. Your booking may be cancelled for failure to provide proof of coverage upon request."
              />
            </Text>
          </li>
          <li style={{ display: 'flex', alignItems: 'start', gap: '8px' }}>
            &bull;
            <Text>
              <FormattedMessage
                id="social_event_policy.accurate_use"
                defaultMessage="Your booking request must accurately reflect your use of the space, including the number of attendees and whether there will be alcohol present, if applicable."
              />
            </Text>
          </li>
          <li style={{ display: 'flex', alignItems: 'start', gap: '8px' }}>
            &bull;
            <Text>
              <FormattedMessage
                id="social_event_policy.responsible_guest"
                defaultMessage="As the Peerspace guest, you are responsible for the behavior of your attendees and any damage they may cause."
              />
            </Text>
          </li>
        </ul>
      </div>

      <SocialEventPolicyForm urlPrefix={urlPrefix} />
    </div>
  );
};

SocialEventPolicySection.propTypes = {
  urlPrefix: PropTypes.string
};
